export default __webpack_public_path__ + "ed04cf5ebc21986cfcf5157cb36400cc.svg";